import { render, staticRenderFns } from "./EventItemModal.vue?vue&type=template&id=adc7a602"
import script from "./EventItemModal.vue?vue&type=script&lang=ts"
export * from "./EventItemModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports